interface FloatingElementsProps {
  delay?: number;
}

export const FloatingElements = ({ delay = 1000 }: FloatingElementsProps) => {
  return (
    <>
      <div 
        className="absolute top-1/4 left-1/4 w-20 h-20 bg-accent/30 rounded-full opacity-0 animate-[fade-in_0.5s_ease-out_1s_forwards,float_6s_ease-in-out_1.5s_infinite]" 
        aria-hidden="true" 
        style={{ animationDelay: `${delay}ms` }}
      />
      <div 
        className="absolute top-1/3 right-1/4 w-16 h-16 bg-fun/30 rounded-full opacity-0 animate-[fade-in_0.5s_ease-out_1.2s_forwards,bounce-gentle_2s_ease-in-out_1.7s_infinite]" 
        aria-hidden="true"
        style={{ animationDelay: `${delay + 200}ms` }}
      />
      <div 
        className="absolute bottom-1/4 left-1/3 w-12 h-12 bg-secondary/30 rounded-full opacity-0 animate-[fade-in_0.5s_ease-out_1.4s_forwards,float_6s_ease-in-out_1.9s_infinite]" 
        aria-hidden="true"
        style={{ animationDelay: `${delay + 400}ms` }}
      />
    </>
  );
};